<script setup>
import { ref } from 'vue';
import MazDialog from 'maz-ui/components/MazDialog';
import CarLoader from "@/components/common/utils/CarLoader.vue";
import LocalStorage from '@/controller/LocalStorage.js';
import { useRouter } from 'vue-router';
import { ws_base } from '@/conf/conf.js';


const props = defineProps({
  media: Array,
  isMobileView: Boolean,
  mediaNumber: Number,
  workfileId: String,
});



const pdfIcon = '/public/assets/workfiles/PDF.svg';
const recIcon = '/public/assets/workfiles/rec.svg';
const audioIcon = '/public/assets/workfiles/audio.svg';
const csvIcon = '/public/assets/workfiles/csv.svg';
const footerVideoIcon = '/public/assets/workfiles/video_media.svg';
const downloadIconBlue = '/public/assets/workfiles/download_blue.svg'

const router = useRouter();
const userColor = ref(LocalStorage.getColor());
const userKey = ref(LocalStorage.getKey());
const path =  router.currentRoute.value.params.id;

const isModalOpen = ref(false);
const modalContent = ref({ type: null, link: '' });

const videoDurations = ref([]); 
const audioDurations = ref([]);
const isLoading = ref([]);


const initializeLoadingState = () => {
  isLoading.value = props.media.map((item) => item.type === 0 || item.type === 1);
};

const handleLoad = (index) => {
  isLoading.value[index] = false;
};

initializeLoadingState();

const setVideoDuration = (event, index) => {
  const durationInSeconds = event.target.duration;
  const minutes = Math.floor(durationInSeconds / 60);
  const seconds = Math.floor(durationInSeconds % 60).toString().padStart(2, '0');
  videoDurations.value[index] = `${minutes}:${seconds}`;
};
const setAudioDuration = (event, index) => {
  const durationInSeconds = event.target.duration;
  const minutes = Math.floor(durationInSeconds / 60);
  const seconds = Math.floor(durationInSeconds % 60).toString().padStart(2, '0');
  audioDurations.value[index] = `${minutes}:${seconds}`;
};

const openModal = (type, link) => {

    modalContent.value = { type, link };
    isModalOpen.value = true;
};



</script>

<template>
  <hr v-if="isMobileView && mediaNumber > 0" class="separator-mobile" />
  <div class="workfile-media-title" v-if="isMobileView && mediaNumber > 0">
    Media
    <div class="media-number">{{ mediaNumber }}</div>
  </div>
  <div class="workfile-media-container">
    <div v-for="(item, index) in media" :key="index" class="media-card">
      <div v-if="isLoading[index]" class="loader">
        <CarLoader />
      </div>
      <template v-if="item.type === 0">
        <!-- Imagen -->
        <img :src="item.link" class="media-cover" @click="openModal(item.type, item.link)" @load="handleLoad(index)" />
      </template>
      <template v-else-if="item.type === 1">
        <!-- Video -->
        <video :src="item.link" class="media-cover" @click="openModal(item.type, item.link)"
          @loadeddata="handleLoad(index)" @loadedmetadata="(e) => setVideoDuration(e, index)"></video>
        <div class="video-footer" v-if="videoDurations[index]">
          <img :src="footerVideoIcon" style="width: 15px; height: auto;">
          <p class="duration"> {{ videoDurations[index] }}</p>
        </div>
      </template>
      <template v-else-if="item.type === 2">
        <!-- Audio -->
        <img :src="audioIcon" class="media-cover-logo"
          style="position: absolute; max-width: 65px; height: auto; padding: 0.5rem;"
          @click="openModal(item.type, item.link)" />
        <audio :src="item.link" @loadedmetadata="(e) => setAudioDuration(e, index)"></audio>
        <div class="audio-footer" v-if="audioDurations[index]">
          <p class="duration"> {{ audioDurations[index] }}</p>
        </div>
      </template>
      <template v-else-if="item.type === 3 || item.type === 4">
        <!-- Documentos e Invoice -->
        <a :href="item.link" target="_blank">
          <img :src="pdfIcon" class="media-cover-logo" v-if="item.extension== '.pdf'" />
          <img :src="recIcon" class="media-cover-logo" v-if="item.extension== '.rec'" />
          <img :src="csvIcon" class="media-cover-logo" v-if="item.extension== '.csv'" />
        </a>
      </template>

    </div>
    <MazDialog v-model="isModalOpen" class="media-modal">
      <div v-if="modalContent.type === 0">
        <img class="media-modal-content" :src="`${modalContent.link}&orig=1`" alt="Image" />
      </div>
      <div v-else-if="modalContent.type === 1">
        <video class="media-modal-content" :src="modalContent.link" controls></video>
      </div>
      <div v-else-if="modalContent.type === 2">
        <audio style="width: 100%;" :src="modalContent.link" controls></audio>
      </div>
      <template #footer="{ close }">
      </template>
    </MazDialog>
  </div>
  <div v-if="isMobileView && mediaNumber > 0" class="download-mobile">
    <a class="download-button-mobile" :href="`${ws_base}/workfile/${path}/medias?token=${userKey}`" target="_blank">
      <img :src="downloadIconBlue" class="download-button-logo-mobile">
    </a>
  </div>

</template>

<style lang="scss" scoped>

.separator-mobile {
  margin-top: 20px;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  opacity: 0.25;
  margin-bottom: 20px;
  justify-self: center;
  width: calc(100% + 25px);
  margin-left: 0px;
  margin-right: -20px;
}

.workfile-media-title {
  font-family: 'CircularStd-Bold';
  font-size: 18px;
  color: #153440;
  margin-left: 1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.2rem;
  .media-number{
        background-color: v-bind(userColor);
        color: white;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        margin-left: 0.1rem;
    }
}

.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  
}

.media-modal{

  .media-modal-content {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 70vh; 
    object-fit: contain; 
    border-radius: 10px;
    display: block;
    margin: 0 auto; 
  }
}

.video-footer {
  position: absolute;
  width: 100%;
  align-self: end;
  color: white;
  padding: 0.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 13px;

  .duration{
    margin: 0px;
  }
}

.audio-footer{
  position: absolute;
  width: 100%;
  align-self: end;
  color: white;
  padding: 0.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 13px;
  .duration{
    margin: 0px;
  }
}

.workfile-media-container {
  background-color: #F2F2F2;
  margin: 4rem;
  margin-bottom: 1.5rem;
  border-radius: 25px;
  height: auto;   
  max-height: 250px;
  overflow-y: scroll;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem; 
  padding: 1rem;
  width: 90%;
  scrollbar-color: #153440;
  scrollbar-width: thin;
  scrollbar-gutter: stable;
}

.media-card {
  width: 130px;
  height: 90px;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #A7ACB7;
  border-radius: 10px;
  overflow: hidden; 
  cursor: pointer;
}

.media-cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.media-cover-logo {
  width: 100%;
  height: 100%;
  padding: 2.7rem;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 500px;
  height: 500px;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  padding: 1rem;
  border-radius: 10px;
  position: relative;
  max-width: 90%;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.modal-image, .modal-video {
  max-width: 100%;
  max-height: 100%;
  border-radius: 10px;
}

.modal-close {
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.download-mobile {
  display: flex;
  width: 100%;
  justify-content: end;
  padding-right: 1.5rem;
  align-items: center;
  margin-top: 0.5rem;
  .download-button-logo-mobile{
    width: 25px;
  }
}

@media (max-width:576px) {
  .workfile-media-container {
    margin: 0;
    margin-top: 0.1rem;
    width: 100%;
    max-height: 130px;
    overflow-y: auto;
    background-color: transparent;
    gap: 0.5rem; 
  }

  .media-card {
  width: 80px;
  height: 50px;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #A7ACB7;
  border-radius: 10px;
  overflow: hidden; 
}

  .media-cover-logo {
    width: 30px;
    height: auto;
    justify-self: center;
    align-self: center;
    object-fit: cover;
  }

  .audio-footer {
    position: absolute;
    width: 100%;
    align-self: end;
    color: white;
    padding: 0.3rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: end;
    padding-left: 1rem;
    padding-right: 0.5rem;
    font-size: 13px;
  }
}
@media (min-width: 768px) and (max-width: 1367px) and (orientation: portrait) {
  .workfile-media-container {
    margin-right: 2rem;
  }
  .media-card {
    width: 85px;
    height: 70px;
  }
}

@media (min-width: 1024px) and (max-width: 1367px) and (orientation: landscape) {
  .workfile-media-container {
    margin-right: 2rem;
  }
  .media-card {
    width: 110px;
    height: 85px;
  }
}

@media (min-width:577px) and (max-width: 767px) and (orientation:portrait){
    .workfile-media-container {
      margin-right: 1.5rem;
    }
}

@media (min-width:577px) and (max-width: 1024px) and (orientation:landscape){
  .workfile-media-container {
      
      margin-right: 1.5rem;
    }

}
</style>